<template>
  <v-content class="pa-0 ">
    <v-row justify="center" no-gutters> 
      <v-col cols="12" sm="9" xl="6" lg="6" >
        
        <v-snackbar v-model="snackbar" :timeout="4000" :color="color" top> {{text}}
          <v-btn color="white" text @click="snackbar = false" > Cerrar  </v-btn>
        </v-snackbar>
        <v-card-text align="left">
          <v-card-actions>
            <v-card-title class="font-weight-black headline ">
              Mi perfil 
              <span class="overline mt-2 mx-3"> ({{ usuario.nivel ==='ADMIN'? 'Administrador':'Cliente' }}) </span>
            </v-card-title>
            <v-spacer></v-spacer>
            <v-btn color="secondary" dark large icon onClick="history.go(-1); return false;">
              <v-icon large >mdi-arrow-left-thick</v-icon>
            </v-btn>
          </v-card-actions>
          
            <v-form ref="form" v-model="valid" :lazy-validation="lazy" >
              <v-row>
                <v-col cols="12" v-show="false">
                  <v-select 
                    v-model="nivel" :items="niveles" outlined prepend-icon="call_split"
                    label="Nivel" return-object hide-details dense item-text="nombre" item-value="clave"
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="6"> 
                  <v-row> 
                    <v-col cols="12" >
                      <v-text-field 
                        :rules="nameRules"
                        v-model="usuario.nombre" 
                        color="secondary"
                        clearable
                        hide-details 
                        prepend-icon="person" 
                        label="Nombre de usuario" 
                        outlined dense 
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field 
                        :rules="nameRules"
                        v-model="usuario.apellidos" 
                        color="secondary"
                        clearable
                        hide-details 
                        prepend-icon="person" 
                        label="apellidos" 
                        outlined dense 
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" >
                      <v-text-field 
                        v-model.number="usuario.telmovil" 
                        color="secondary"
                        clearable
                        hide-details 
                        prepend-icon="phone" 
                        label="Telefono celular" 
                        outlined dense 
                        type="number"
                        required
                        :disabled="usuario.nivel ==='ADMIN'"
                        :rules="[v => !!v || 'Item is required']"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field 
                        v-model="usuario.email" 
                        color="secondary"
                        clearable
                        hide-details 
                        prepend-icon="email" 
                        label="Correo" 
                        outlined dense 
                        required
                        :rules="[v => !!v || 'Item is required']"
                        ></v-text-field>
                    </v-col>

                    <v-card-actions class="mx-9">
                      <v-spacer></v-spacer>
                      <v-btn small  color="success"  @click="cambiaPassword = !cambiaPassword" v-if="cambiaPassword"> Cambiar Contraseña	</v-btn>
                      <v-btn small  color="error" dark @click="cambiaPassword = !cambiaPassword" v-if="!cambiaPassword"> Cancelar </v-btn>
                    </v-card-actions>

                    <v-card-text v-if="!cambiaPassword">
                      <v-text-field
                        v-model="password"
                        prepend-icon="lock"
                        :append-icon="show1 ? 'visibility_off' : 'visibility'"
                        :type="show1 ? 'text' : 'password'"
                        label="Contraseña"
                        clearable
                        outlined
                        dense
                        @click:append="show1 = !show1"
                        :rules="[v => !!v || 'Item is required']"
                      ></v-text-field>
                      
                      <v-text-field
                        v-model="password2"
                        prepend-icon="lock"
                        :append-icon="show2 ? 'visibility_off' : 'visibility'"
                        :type="show2 ? 'text' : 'password'"
                        label=" Confirmar Contraseña"
                        clearable
                        outlined
                        dense
                        @click:append="show2 = !show2"
                        :rules="[v => !!v || 'Item is required']"
                      ></v-text-field>
                    </v-card-text>

                  </v-row>
                </v-col>
                <v-col cols="12" sm="6"> 
                  <v-row>
                    <v-col cols="12" >
                      <v-text-field 
                        v-model="usuario.empresa" 
                        prepend-icon="domain" 
                        label="Empresa" 
                        outlined dense 
                        color="secondary"
                        clearable
                        hide-details
                        :disabled="usuario.nivel ==='ADMIN'"
                        required
                        :rules="[v => !!v || 'Item is required']"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" >
                      <v-text-field 
                        v-model.number="usuario.telempresa" 
                        prepend-icon="contact_phone" 
                        label="Telefono de empresa" 
                        outlined dense 
                        type="number"
                        color="secondary"
                        clearable
                        hide-details
                        :disabled="usuario.nivel ==='ADMIN'"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" >
                      <v-text-field 
                        prepend-icon="account_balance_wallet" 
                        label="Modelo de la maquina" 
                        outlined dense 
                        color="secondary"
                        clearable
                        hide-details
                        :disabled="usuario.nivel ==='ADMIN'"
                        v-model="usuario.modmaquina"
                        required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" >
                      <v-text-field 
                        v-model="usuario.matserie" 
                        prepend-icon="format_list_numbered_rtl" 
                        label="Matricula/Serie" 
                        outlined dense 
                        color="secondary"
                        clearable
                        hide-details
                        required
                        :disabled="usuario.nivel ==='ADMIN'"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          <v-card-actions> <v-spacer></v-spacer>
            <v-btn  small color="primary" @click="update()" :disabled="!valid">
              Guardar Información
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-col>
    </v-row>
  </v-content>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'
  var md5     = require('md5')

  export default{
    data(){
      return{
        valid:true,
        lazy: false,
        usuario:[],
        show: false,
        show1: false,
        show2: false,

        passwordActual:'',
        cambiaPassword:true,

        nivel:{ clave:'', nombre:''},
        niveles: [{clave:'ADMIN', nombre:'Administrador'},{clave:'USER',nombre:'Cliente'}],
        password:'',
        password2:'',

        snackbar: false,
        color : 'red darken-4',
        text:'',

        nameRules: [
          v => !!v || 'Name is required',
          v => (v && v.length <= 60) || 'Name must be less than 10 characters',
        ],
        emailRules: [
          v => !!v || 'E-mail is required',
          v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
        ],

      }
    },

    created () {
      console.log('getdatosUsuario',this.getdatosUsuario) 
      this.cargarInfo(this.getdatosUsuario.idusuariosweb)
      // this.idusuariosweb = this.$route.params.idusuariosweb
    },

 

    methods:{
      cargarInfo(id){
        this.$http.get('users/' + id).then(response => { 
          this.usuario = response.body
          this.usuario.nivel ==='ADMIN'?
          this.nivel = { clave:'ADMIN',nombre:'Administrador'}:
          this.nivel = { clave:'USUARIO' ,nombre:'Cliente'};
          this.passwordActual = this.usuario.password;
          console.log('eeeeee', this.passwordActual)
        }).catch(error=>{
            console.log(error)
        })
      },

      update(){
        
        if(!this.cambiaPassword){
          if(this.password.localeCompare(this.password2) ){
            this.text     = "Las contraseñas no coinciden"
            this.snackbar = true
            return
          }
        }

        var md5 = require('md5');
        var id =  this.getdatosUsuario.idusuariosweb
        
        const payload ={ 
                        id: this.getdatosUsuario.idusuariosweb,
                        nombre: this.usuario.nombre,
                        apellidos: this.usuario.apellidos,
                        telmovil: this.usuario.telmovil,
                        email: this.usuario.email,
                        password: this.cambiaPassword ? this.passwordActual: md5(this.password),
                        empresa: this.usuario.empresa,
                        telempresa: this.usuario.telempresa,
                        modmaquina: this.usuario.modmaquina,
                        matserie: this.usuario.matserie,
                        nivel: this.nivel.clave 
                      }

        this.$http.post('update.usuario', payload).then(response=>{
          console.log('response', response.body)
          this.snackbar = true 
          this.text ="Los datos han sido actualizados "
          this.color ="green"
          this.password = ''
          this.password2 = ''
          this.contra = false
          this.cargarInfo(id)
        }).catch(error=>{console.log(error)})
      }

    },
    computed:{
      ...mapGetters('Login',['getdatosUsuario', 'getLogeado']),

    },

  };
</script>